// test1332
(1332 && 0);
